<template>
  <div class="my-2" style="height: calc(490px - 65px); overflow-y:auto;">
    <b-tabs content-class="mt-3">
      <b-tab title="Setup" class="text-left" active>
        <b-form-group label="Pri Title">
          <b-form-input disabled type="text" v-model="form.setup.priTitle"></b-form-input>
        </b-form-group>
        <b-form-group label="Select the required indicators">
          <b-form-checkbox disabled v-model="form.showSanctions">Sanctions and Enforcement</b-form-checkbox>
          <b-form-checkbox disabled v-model="form.showNegativeMedia">Negative Media</b-form-checkbox>
          <div class="ml-5" v-if="form.showNegativeMedia">
            <b-form-group label="Categories">
              <b-form-checkbox
                disabled
                inline
                v-model="formData.setup.negativeMedia.selectedCategories"
                v-for="(priType,index) in priTypes"
                :key="index"
                :value="priType"
              >{{priType.text}}</b-form-checkbox>
            </b-form-group>
          </div>

          <b-form-checkbox disabled v-model="form.showCountry">Country</b-form-checkbox>
          <b-form-checkbox disabled v-model="form.showIndustry">Industry</b-form-checkbox>
          <b-form-checkbox disabled v-model="form.showCustomIndicators">Custom Indicators</b-form-checkbox>
          <b-form-checkbox disabled v-model="form.showFutureRisks">Future Risks</b-form-checkbox>
          <div class="ml-5" v-if="form.showFutureRisks">
            <b-form-group label="Categories">
              <b-form-checkbox
                disabled
                inline
                v-model="formData.setup.futureRisks.selectedCategories"
                v-for="(priType,index) in priTypes"
                :key="index"
                :value="priType"
              >{{priType.text}}</b-form-checkbox>
            </b-form-group>
          </div>
          <b-form-checkbox disabled v-model="form.showOpenCorporate">Open Corporate</b-form-checkbox>
          <b-form-checkbox disabled v-model="form.showPublicListing">Public Listing</b-form-checkbox>
        </b-form-group>
      </b-tab>
      <b-tab title="Sanctions & Enforcements" class="text-left" v-if="form.showSanctions">
        <SanctionsEnforcementsComponent :searchPage="true" />
      </b-tab>
      <b-tab title="Negative Media" v-if="form.showNegativeMedia">
        <NegativeMediaComponent
          :negativeMediaEdit="negativeMediaEdit"
          :searchPage="true"
          :categories="formData.setup.negativeMedia.selectedCategories"
        />
      </b-tab>
      <b-tab title="Country" class="text-left" v-if="form.showCountry">
        <CountryComponent :searchPage="true" />
      </b-tab>
      <b-tab class="text-left" title="Custom Indicators" v-if="form.showCustomIndicators">
        <CustomIndicatorsComponent :customIndicatorsData="customIndicators" :searchPage="true" />
      </b-tab>
      <b-tab class="text-left" title="Weightings">
        <WeightingsComponent
          :showCustomIndicators="form.showCustomIndicators"
          :defaultIndicatorsData="defaultIndicators"
          :customIndicatorsData="customIndicators"
          :searchPage="true"
        />
      </b-tab>
      <b-tab class="text-left" title="Future Risks" v-if="form.showFutureRisks">
        <b-tabs>
          <b-tab title="Configration">
            <div class="ml-5">
              <b-form-group label="Categories">
                <b-form-checkbox
                  disabled
                  inline
                  v-model="formData.setup.futureRisks.selectedCategories"
                  v-for="(priType,index) in priTypes"
                  :key="index"
                  :value="priType"
                >{{priType.text}}</b-form-checkbox>
              </b-form-group>
            </div>
            <b-form-group>
              <b-form-checkbox disabled>Search PDF</b-form-checkbox>
              <b-form-checkbox disabled>Human Rights</b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab
            :title="type.text"
            v-for="(type,index) in formData.setup.futureRisks.selectedCategories"
            :key="index"
          >
            <FutureRisksComponent
              :searchPage="true"
              :futureRisksEdit="futureRisksEdit"
              :tabIndex="index"
            />
          </b-tab>
        </b-tabs>
      </b-tab>
      <b-tab class="text-left" title="Open Corporate" v-if="form.showOpenCorporate">
        <OpenCorporateComponent :searchPage="true" />
      </b-tab>
      <b-tab class="text-left" title="Public Listing" v-if="form.showPublicListing">
        <PublicListingComponent :searchPage="true" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import NegativeMediaComponent from "../addPriModal/negativeMedia.vue";
import SanctionsEnforcementsComponent from "../addPriModal/sanctionsEnforcementsComponent.vue";
import CountryComponent from "../addPriModal/countryComponent.vue";
import CustomIndicatorsComponent from "../addPriModal/customIndicatorsComponent.vue";
import WeightingsComponent from "../addPriModal/weightingsComponent.vue";
import FutureRisksComponent from "../addPriModal/futureRisksComponent.vue";
import OpenCorporateComponent from "../addPriModal/openCorporateComponent.vue";
import PublicListingComponent from "../addPriModal/publicListingComponent.vue";
export default {
  name: "ConfigurationComponent",
  components: {
    NegativeMediaComponent,
    FutureRisksComponent,
    SanctionsEnforcementsComponent,
    CountryComponent,
    CustomIndicatorsComponent,
    WeightingsComponent,
    OpenCorporateComponent,
    PublicListingComponent
  },
  data() {
    return {
      futureRisksEdit: false,
      negativeMediaEdit: false,
      formData: {
        setup: {
          negativeMedia: {
            selectedCategories: []
          },
          futureRisks: {
            selectedCategories: []
          }
        }
      },
      priTypes: [
        { text: "Anti-Corruption & Bribery", value: 1 },
        { text: "Human Rights", value: 2 },
        { text: "Animal Welfare", value: 3 },
        { text: "Data Privacy", value: 4 },
        { text: "Information Security", value: 5 }
      ],
      customIndicators: [],
      defaultIndicators: [
        { text: "Sanctions and enforcement ", value: 25, key: "sanctions" },
        { text: "Negative Media", value: 50, key: "negative" },
        { text: "Country", value: 25, key: "country" },
        { text: "Industry", value: 25, key: "industry" }
      ]
    };
  },
  mounted() {
    this.showEditModal();
    this.priTypes.map((type, index) => {
      this.setNegativeMediaCategories(index);
      this.setFutureRisksCategories(index);
    });
  },
  methods: {
    setNegativeMediaCategories(index) {
      this.$store.state.priConfigrationforms.negativeMedia.categories.push({
        customGoogleSearchEngineSites: null,
        searchKeywords: [],
        searchKeywordsNlp: [],
        searchExcludeKeywords: [],
        stopWords: [],
        exactPhraseMatch: 1,
        sortResult: 1,
        numberOfResults: { value: 1, text: "10" },
        google: 1,
        bing: 1,
        language: { value: "lang_en", text: "English" },
        lowerUpperLimit: 30,
        mediumUpperLimit: 32,
        prePendSearchText: null,
        appendSearchText: null
      });
    },
    setFutureRisksCategories(index) {
      this.$store.state.priConfigrationforms.futureRisks.categories.push({
        customGoogleSearchEngineSites: null,
        searchKeywords: [],
        searchKeywordsNlp: [],
        searchExcludeKeywords: [],
        stopWords: [],
        exactPhraseMatch: 1,
        sortResult: 1,
        numberOfResults: { value: 1, text: "10" },
        google: 1,
        bing: 1,
        language: { value: "lang_en", text: "English" },
        lowerUpperLimit: 30,
        mediumUpperLimit: 32,
        prePendSearchText: null,
        appendSearchText: null
      });
    },
    showEditModal() {
      this.defaultIndicators = [];
      this.defaultIndicators = this.form.weighting.defaultIndicators;
      this.form.customIndicationsSettings.customIndicatorsTabs.map(
        customIndicatorsValue => {
          this.customIndicators.push(customIndicatorsValue.item);
        }
      );
      this.formData.setup.negativeMedia.selectedCategories = this.form.setup.negativeMedia.selectedCategories;
      this.formData.setup.futureRisks.selectedCategories = this.form.setup.futureRisks.selectedCategories;
      this.$store.state.priConfigrationforms.sanctions = this.form.sanctions;
      this.$store.state.priConfigrationforms.countryRules = this.form.countryRules;
      this.$store.state.priConfigrationforms.customIndicationsSettings = this.form.customIndicationsSettings;
      this.$store.state.priConfigrationforms.weighting = this.form.weighting;
      this.$store.state.priConfigrationforms.openCorporate = this.form.openCorporate;
      this.$store.state.priConfigrationforms.publicListings = this.form.publicListings;
      this.negativeMediaEdit = true;
      this.$store.state.priConfigrationforms.negativeMedia.categories = [];
      if (this.form.negativeMedia.categories.length > 0) {
        this.form.negativeMedia.categories.map(negativeMediaData => {
          this.$store.state.priConfigrationforms.negativeMedia.categories.push(
            negativeMediaData.settings
          );
        });
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          categoriesData => {
            this.$store.state.priConfigrationforms.negativeMedia.categories.push(
              categoriesData
            );
          }
        );
      }

      this.futureRisksEdit = true;
      this.$store.state.priConfigrationforms.futureRisks.categories = [];

      if (this.form.futureRisks.categories.length > 0) {
        this.form.futureRisks.categories.map(futureRisksData => {
          this.$store.state.priConfigrationforms.futureRisks.categories.push(
            futureRisksData.settings
          );
        });
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          categoriesData => {
            this.$store.state.priConfigrationforms.futureRisks.categories.push(
              categoriesData
            );
          }
        );
      }
    }
  },
  props: {
    form: Object
  }
};
</script>